import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

const anyItemGroupsHaveCopy = itemGroups => !itemGroups.filter(item => item.get('copy', false)).isEmpty();

const anyItemGroupsHaveVolume = itemGroups => !itemGroups.filter(item => item.get('volume', false)).isEmpty();

const getLocalizationForTitle = itemGroups => {
  const someHaveCopy = anyItemGroupsHaveCopy(itemGroups);
  const someHaveVolume = anyItemGroupsHaveVolume(itemGroups);

  if (someHaveCopy && !someHaveVolume) {
    return 'section_title_copy_for_title';
  }
  if (someHaveVolume && !someHaveCopy) {
    return 'section_title_volume_for_title';
  }

  // If there is a mix of copies and volumes, or no items have either, just say "item"
  return 'section_title_item_for_title';
};

export default function ItemLevelHoldsWorkflowTitle({ itemGroups, bibTitle }) {
  return (
    <h2 className="cp-item-level-holds-workflow-title">
      <FormattedMessage id={getLocalizationForTitle(itemGroups)} values={{ title: bibTitle }} />
    </h2>
  );
}

ItemLevelHoldsWorkflowTitle.propTypes = {
  itemGroups: ImmutablePropTypes.list,
  bibTitle: PropTypes.string
};
